/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderPaymentMethod } from './OrderPaymentMethod';
import {
    OrderPaymentMethodFromJSON,
    OrderPaymentMethodFromJSONTyped,
    OrderPaymentMethodToJSON,
    OrderPaymentMethodToJSONTyped,
} from './OrderPaymentMethod';

/**
 * 
 * @export
 * @interface PaymentStatistics
 */
export interface PaymentStatistics {
    /**
     * 
     * @type {OrderPaymentMethod}
     * @memberof PaymentStatistics
     */
    paymentMethod?: OrderPaymentMethod;
    /**
     * 
     * @type {number}
     * @memberof PaymentStatistics
     */
    amountNet?: number;
    /**
     * 
     * @type {number}
     * @memberof PaymentStatistics
     */
    amountGross?: number;
}

/**
 * Check if a given object implements the PaymentStatistics interface.
 */
export function instanceOfPaymentStatistics(value: object): value is PaymentStatistics {
    return true;
}

export function PaymentStatisticsFromJSON(json: any): PaymentStatistics {
    return PaymentStatisticsFromJSONTyped(json, false);
}

export function PaymentStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentStatistics {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentMethod': json['paymentMethod'] == null ? undefined : OrderPaymentMethodFromJSON(json['paymentMethod']),
        'amountNet': json['amountNet'] == null ? undefined : json['amountNet'],
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
    };
}

export function PaymentStatisticsToJSON(json: any): PaymentStatistics {
    return PaymentStatisticsToJSONTyped(json, false);
}

export function PaymentStatisticsToJSONTyped(value?: PaymentStatistics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentMethod': OrderPaymentMethodToJSON(value['paymentMethod']),
        'amountNet': value['amountNet'],
        'amountGross': value['amountGross'],
    };
}

